export default {
  name: 'about',
  props: {
    msg: String
  }
}